import '@/utils/chrom_fix.js'
import '@/assets/font/iconfont.css'
import {createApp} from 'vue'
import '@/styles/base.scss'
import App from './App.vue'
import router from './router'
import store from './store'

import Vant from 'vant'
import 'vant/lib/index.css'

import 'amfe-flexible/index'
// 事件总线
import mitt from 'mitt'
import {loadLang} from '@/lang/index.js'
import {resetForm} from '@/utils/common.js'
import TlbsMap from 'tlbs-map-vue'

import VConsole from 'vconsole'


const app = createApp(App)
app.use(router)
app.use(store)
app.use(TlbsMap)
app.config.globalProperties.resetForm = resetForm
app.config.globalProperties.eventBus = mitt()
console.log(import.meta.env)
if (localStorage.getItem('debug') === 'ON') {
  const vConsole = new VConsole()
  console.info('VConsole init:', vConsole.isInited)
}
new Promise((resolve) => {
  resolve(loadLang())
}).then((i18n) => {
  app.use(i18n)
  app.use(Vant, {i18n: i18n.global.t})
  app.mount('#app')
})
